module.exports = "\n<div>\n  <personal-data :user=\"thisuser\" :user-role=\"user\"></personal-data>\n  <!-- <md-button\n          class=\"waves-effect waves-light purple darken-4\"\n          v-if=\"thisuser.username === user.username\"\n          v-link=\"{name: 'edituser'}\"\n  >\n    <md-icon right>edit</md-icon>\n    {{ $t(\"account.personalData.edit\") }}\n  </md-button>-->\n\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/user/account/data.vue
// module id = 527
// module chunks = 11